/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePayrollItemRequest } from '../models/CreatePayrollItemRequest';
import type { Page_PayrollItemResponse_ } from '../models/Page_PayrollItemResponse_';
import type { PayrollItemDto } from '../models/PayrollItemDto';
import type { PayrollItemProjection } from '../models/PayrollItemProjection';
import type { PayrollItemResponse } from '../models/PayrollItemResponse';
import type { UpdatePayrollItemRequest } from '../models/UpdatePayrollItemRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PayrollItemControllerService {
  /**
   * getAllPayrollItems
   * @returns Page_PayrollItemResponse_ OK
   * @throws ApiError
   */
  public static getAllPayrollItemsUsingGet({
    limit = 10,
    offset,
    search,
    type,
  }: {
    /**
     * limit
     */
    limit?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * search
     */
    search?: string;
    /**
     * type
     */
    type?: 'DEDUCTION' | 'ENTITLEMENT';
  }): CancelablePromise<Page_PayrollItemResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/items',
      query: {
        limit: limit,
        offset: offset,
        search: search,
        type: type,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createPayrollItem
   * @returns PayrollItemResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static createPayrollItemUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreatePayrollItemRequest;
  }): CancelablePromise<PayrollItemResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payroll/items',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAllDeductions
   * @returns PayrollItemDto OK
   * @throws ApiError
   */
  public static getAllDeductionsUsingGet(): CancelablePromise<Array<PayrollItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/items/deductions',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAllEntitlements
   * @returns PayrollItemDto OK
   * @throws ApiError
   */
  public static getAllEntitlementsUsingGet(): CancelablePromise<Array<PayrollItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/items/entitlements',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAllPayrollItemProjections
   * @returns PayrollItemProjection OK
   * @throws ApiError
   */
  public static getAllPayrollItemProjectionsUsingGet({
    type,
  }: {
    /**
     * type
     */
    type?: 'DEDUCTION' | 'ENTITLEMENT';
  }): CancelablePromise<Array<PayrollItemProjection>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/items/projections',
      query: {
        type: type,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getPayrollItem
   * @returns PayrollItemResponse OK
   * @throws ApiError
   */
  public static getPayrollItemUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<PayrollItemResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/items/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updatePayrollItem
   * @returns PayrollItemResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static updatePayrollItemUsingPut({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: UpdatePayrollItemRequest;
  }): CancelablePromise<PayrollItemResponse | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/payroll/items/{id}',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deletePayrollItem
   * @returns any OK
   * @throws ApiError
   */
  public static deletePayrollItemUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/payroll/items/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
